// Global State
export const state = {
  allQuestions: [],
  explanations: {}, // { [questionId]: "Explanation text" }
  mode: null, // 'practice' or 'test'
  // Persisted Data
  userProgress: {
    history: {}, // { [questionId]: [{ date: number, correct: boolean }] }
    testHistory: [], // [{ date: string, score: number, total: number, passed: boolean }]
  },
  // Practice Mode State
  practice: {
    deck: [],
    topic: null,
    sessionCount: 0,
    reviewOnly: false,
  },
  // Test Mode State
  test: {
    questions: [],
    currentIndex: 0,
    score: 0,
    totalQuestions: 0,
    timerInterval: null,
    timeLeft: 0,
  },
  sessionStreak: 0,
  currentQuestion: null,
  theme: "system", // 'light', 'dark', 'system'
};

// DOM Elements
export const els = {
  loading: document.getElementById("loading"),
  menu: document.getElementById("menu-container"),
  quiz: document.getElementById("quiz-container"),
  results: document.getElementById("results-container"),
  stats: document.getElementById("stats-container"),

  // Quiz Elements
  question: document.getElementById("question-text"),
  questionImageContainer: document.getElementById("question-image-container"),
  questionImage: document.getElementById("question-image"),
  options: document.getElementById("options-container"),
  nextBtn: document.getElementById("next-btn"),
  progress: document.getElementById("progress-text"),
  topicLabel: document.getElementById("topic-label"),
  score: document.getElementById("score-text"),
  timer: document.getElementById("timer-text"),
  masteryBadgeContainer: document.getElementById("mastery-badge-container"),
  explanationText: document.getElementById("explanation-text"),
  btnQuit: document.getElementById("btn-quit"),

  // Flashcard Elements
  flashcardContainer: document.getElementById("flashcard-container"),
  flashcardInner: document.querySelector(".flashcard-inner"),
  flashcardFront: document.getElementById("flashcard-front-content"),
  flashcardBack: document.getElementById("flashcard-back-content"),

  // Buttons
  btnPractice: document.getElementById("btn-practice"),
  btnPracticeReview: document.getElementById("btn-practice-review"),
  btnFlashcard: document.getElementById("btn-flashcard"),
  btnFlashcardReview: document.getElementById("btn-flashcard-review"),
  btnTestMini: document.getElementById("btn-test-mini"),
  btnTestFull: document.getElementById("btn-test-full"),
  btnStats: document.getElementById("btn-stats"),
  btnHome: document.getElementById("btn-home"),
  themeToggle: document.getElementById("theme-toggle"),
  btnStatsBack: document.getElementById("btn-stats-back"),
  btnResultsBack: document.getElementById("btn-results-back"),

  // Results
  resultTitle: document.getElementById("result-title"),
  resultMessage: document.getElementById("result-message"),

  // Stats
  dailyStats: document.getElementById("daily-stats"),
  sectionStats: document.getElementById("section-stats"),
  forecastStats: document.getElementById("forecast-stats"),
  insightsStats: document.getElementById("insights-stats"),
};
